import { render, staticRenderFns } from "./InputAlter.vue?vue&type=template&id=e2fbfc88&scoped=true&"
import script from "./InputAlter.vue?vue&type=script&lang=ts&"
export * from "./InputAlter.vue?vue&type=script&lang=ts&"
import style0 from "./InputAlter.vue?vue&type=style&index=0&id=e2fbfc88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fbfc88",
  null
  
)

export default component.exports